import React from 'react'
import ChatLogItemTip from '../ChatLogItemTip'
import Registry from '../../../registry/index'

class ChatLogItemMemberShip extends ChatLogItemTip {
    constructor(props) {
        super(props);
    }

    render() {
        let { message, currentUser } = this.props;

        let bg;
        if(message.duration === 60) {
            bg = "bg1";
        } else if(message.duration === 180) {
            bg = "bg8";
        } else if(message.duration === 365) {
            bg = "bg5";
        }

        let sender = message.senderUser;
        let receiver = message.receiverUser;
        let receiver_nick = message.receiver;

        if (!sender) return null;
        
        let lang = Registry.get('locale');

        let senderBlock = (
            <span
                className={`sender ${sender.nick === currentUser.nick ? 'mention-me' : 'mention'}`}
                onClick={(event) => this.onAuthorLeftClick(event, sender)}
                onContextMenu={(event) => this.onAuthorRightClick(event, sender)}
            >{sender.nick}</span>
        );
        let receiverBlock = (
            <span
                className={`receiver ${receiver_nick === currentUser.nick ? 'mention-me' : 'mention'}`}
                onClick={(event) => receiver ? this.onAuthorLeftClick(event, receiver) : false}
                onContextMenu={(event) => receiver ? this.onAuthorRightClick(event, receiver) : false}
            >{receiver_nick}</span>
        );

        return (
            <div className="tip-notification" ref={(ref) => this.itemElement = ref}>
                <div className="icon-plus-one">
                    <div className={bg}>
                        <div className="duration">
                            {message.duration} <br/>
                            jours
                        </div>
                    </div>
                </div>
                <div className="text">
                    {senderBlock} {lang.membership_gift_public} {receiverBlock}
                </div>
            </div>
        )
    }

}

export default ChatLogItemMemberShip;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemMembership/index.js